import { MemberProfileShortType } from '../../../../../common/types/MemberProfile'

export const DUMMY_PROFILES: MemberProfileShortType[] = [
  {
    "id": "xxxef0c6-d81f-48d0-9f5b-96ebd0c322d9",
    "friendly_id": "xxxyK6xl",
    "membership_type": "NONE",
    "email_address": "",
    "phone_number": null,
    "avatar_url": 'https://legal-utopia-staging-media.s3.amazonaws.com/legal-services/lawyers/avatars/ebeeab43-d779-45bb-bcb7-c2b9203d6fff.jpg?X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=ASIAQBEVWOMZFZZFOPFV%2F20250512%2Feu-west-2%2Fs3%2Faws4_request&X-Amz-Date=20250512T132119Z&X-Amz-Expires=3600&X-Amz-SignedHeaders=host&X-Amz-Security-Token=IQoJb3JpZ2luX2VjEC4aCWV1LXdlc3QtMiJGMEQCIDkACHCFsjbyYjWPnfGiZxPge44P%2FN6HwExWcq9ctBsQAiBakF7Mwabd%2BklLfEcFsjikfi8mapj9ZAlt7w%2FpqqGkIyqXBAjW%2F%2F%2F%2F%2F%2F%2F%2F%2F%2F8BEAIaDDAwMjQ2MTQzMDU3OCIMxyDAcCXdy9cyYMReKusDbNL4iM6yZeNmK9iNeh4AOtfLsnVUEkLmIio5jVA9VV%2B899qUQCOGycc4IvE2Cfg7hGY9%2FzVcQ%2FNZgbRzXF%2BiRPO7SyKwvnNWW%2BoEX8OhAUqp0VdvYnlnj1iRb2wrAwPDf4CiKBGhiMQN4mvv5e8CT62KKtBRAhlCtxbEgiJQrRK9%2FH0jWLbQD3yAm1uySYiVaWuPEyaOPO0Xek%2BVccfPuASIeKHfHKOmxLsiNyYpQcnVB5A0g60aiGAA%2FpOEXOstdj%2BQIHq%2FF7B9JJtflhNbTcYaOb3sYXp69WH%2BrEmJhNTmjoV7fpDk%2FWWaJPATSpD%2FhN9VATPQcMH4NoiItYkb0k2%2Fo8%2FhwSDVkLOW7N%2FtSRAoZNPH33eH1crVbMuV%2BJJJhE9p4W9kHNtUabN%2FWYycfiesTC%2FJm5vEnibmai9DXCD9OO5kfQ4PmAsmIzWRvhKr1CJSPwZeTEKaeCPuCfpsNePfgXgOa0wMGZdnep1FRpjGvjuoV6XnyRjY9jKnNb4YPYfXy6aKVs38eZz2khGcXeGqPd8mEpJEUIDw0Le246%2BhxIoy6SxLaidomW8O4ZHiKqb6LpdWV6WLH19N%2F%2Fu4Cg1b2n48sT1OONLfbpG7675YD8Bnuxhq3yG0EZJQVXZkszNphIyNn%2FS0biowuemHwQY6qAHzLaT9hbzKRtnhOBWsAxkBGrPRFbvQXozdJkN8i69XOrd06JSDJc1ZbmWeaesAA%2BncAifbjsKr8%2FPwStkYTi86a0VM2t%2B0WmmYw0eCDDajY8jie1Axlvf%2BscoxtzfOmRV8PhTNSY%2F8IRBKwS16t12oYf81CV9NiShD%2Bax%2BvSdQh2xus3MDZQ6kCAlWSj%2FT7%2BVqhZsB1sTYi7QTgQtuHVAmvVU1wMrAZLY%3D&X-Amz-Signature=7ca6a2fb1efb663f1e6e083ebdfb8e12b634c0484b81f93a19b5f9bb64904b19',
    "areas_of_law": [
      "Consumer", "Digital", "Retail"
    ],
    "hourly_rate": null,
    "years_of_experience": null,
    "first_name": "Sarach",
    "last_name": "Miller",
    "bio": "Specliazing in Consumer Law, I am dedicated to protecting clients' rights and interests. With a strong background in digital and retail sectors, I provide expert legal advice to navigate complex consumer issues. My goal is to empower clients with knowledge and support, ensuring they make informed decisions.",
    "profile_type": "solicitor",
    "is_favourite": false
  },
  {
    "id": "xxyef0c6-d81f-48d0-9f5b-96ebd0c322d9",
    "friendly_id": "xxyyK6xl",
    "membership_type": "STANDARD",
    "email_address": null,
    "phone_number": null,
    "avatar_url": 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?q=80&w=2787&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fA%3D%3D',
    "areas_of_law": [
      "Family", "Divorce", "Child custody"
    ],
    "hourly_rate": 55,
    "years_of_experience": 9,
    "first_name": "James",
    "last_name": "Smith",
    "bio": "I am a lawyer specliased in family law and divorce. I have been practicing for over 9 years and have a wealth of experience in this area. I am passionate about helping my clients navigate the complexities of family law and achieve the best possible outcomes for their cases.",
    "profile_type": "solicitor",
    "is_favourite": false
  },
  {
    "id": "xxzef0c6-d81f-48d0-9f5b-96ebd0c322d9",
    "friendly_id": "xxzyK6xl",
    "membership_type": "PREMIUM",
    "email_address": null,
    "phone_number": null,
    "avatar_url": null,
    "areas_of_law": [
      "Property", "Real Estate",
    ],
    "hourly_rate": 65,
    "years_of_experience": 10,
    "first_name": "Geoffrey",
    "last_name": "Gibbons",
    "bio": "Dedicated to providing exceptional legal services in property law, I have over 10 years of experience in the field. My expertise includes residential and commercial property transactions, lease agreements, and property disputes. I am committed to ensuring my clients receive the best possible legal advice and representation.",
    "profile_type": "solicitor",
    "is_favourite": false
  }
]